import './pastel.css';
import {illustrationSizes, illustrationSources} from './pastelImages';

export default function PastelIllustration({asset, alt = '', className = '', sizes = illustrationSizes}) {
  return <figure className={`pastel-art ${className}`}>
    <div className="pastel-art__stage">
      <img src={`/qolak/pastel/images/${asset}.webp`} srcSet={illustrationSources(asset)} sizes={sizes} alt={alt} width="1254" height="1254" loading="lazy" decoding="async"/>
    </div>
  </figure>;
}
